import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { ToggleRefinement, RangeInput, SearchBox } from 'react-instantsearch-dom';

import { currencyCode } from 'Helpers/Geo/data';
import PriceRangeFilter from 'Components/Search/PriceRangeFilter';
import FilterToggle from 'Components/Search/FilterToggle';
import ListFilter from 'Components/Search/ListFilter';
import filterMessages from 'Components/Search/FilterMessages';
import { getAllFacets } from 'Redux/ducks/facet';

export default function SearchFilters({ searchState, pathname }) {
  const { formatMessage } = useIntl();

  const [facets, setFacets] = useState([]);

  useEffect(() => {
    getAllFacets().then(setFacets);
  }, []);

  return (
    <React.Fragment>
      <div className="d-none">
        <SearchBox />
      </div>

      {pathname !== '/on-sale' &&
        <div className="FilterToggle FilterToggle--first">
          <div className="FilterToggle__label">
            <div className="FilterToggle__label__text">
              {formatMessage(filterMessages.onsale)}
            </div>
            <div className="FilterToggle__label__icon">
              <ToggleRefinement
                value
                attribute="on_sale"
                label={formatMessage(filterMessages.onsale)}
                defaultRefinement={!!(searchState.toggle && searchState.toggle.on_sale)}
              />
            </div>
          </div>
        </div>
      }

      {(!searchState.sortBy || !searchState.sortBy.includes('price_asc')) ?
        <FilterToggle title={formatMessage(filterMessages.price)} first={pathname === '/on-sale'}>
          <PriceRangeFilter />
        </FilterToggle>
        :
        <div className="d-none">
          {/* Dummy price widget to allow auto price filter on price low-high sort */}
          <RangeInput
            attribute={`price.${currencyCode}`}
            defaultRefinement={{ min: 0.01 }}
            min={0}
          />
        </div>
      }

      <FilterToggle title={formatMessage(filterMessages.platform)}>
        <ListFilter
          long
          translate
          attribute="drm"
          searchable={false}
        />
      </FilterToggle>

      <FilterToggle title={formatMessage(filterMessages.type)}>
        <ListFilter
          long
          translate
          attribute="display_type"
          searchable={false}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.genre)}>
        <ListFilter
          long
          operator="and"
          attribute="genresSlug"
          facets={facets.filter(f => f.subFacet === 'genres')}
          title={formatMessage(filterMessages.genre)}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.features)}>
        <ListFilter
          long
          translate
          operator="and"
          attribute="features"
        />
      </FilterToggle>

      <FilterToggle title={formatMessage(filterMessages.operating_system)}>
        <ListFilter
          translate
          attribute="operating_systems"
        />
      </FilterToggle>

      <FilterToggle title={formatMessage(filterMessages.steam_deck_support)}>
        <ListFilter
          translate
          allowedValues={['verified', 'playable']}
          attribute="steam_deck_support"
        />
      </FilterToggle>

      <FilterToggle title={formatMessage(filterMessages.vrfeatures)}>
        <ListFilter
          long
          translate
          operator="and"
          attribute="vr_support"
          searchable={false}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.playstyles)}>
        <ListFilter
          long
          operator="and"
          attribute="playstylesSlug"
          facets={facets.filter(f => f.subFacet === 'playstyles')}
          title={formatMessage(filterMessages.playstyles)}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.themes)}>
        <ListFilter
          long
          operator="and"
          attribute="themesSlug"
          facets={facets.filter(f => f.subFacet === 'themes')}
          title={formatMessage(filterMessages.themes)}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.publishers)}>
        <ListFilter
          long
          attribute="publishers"
          title={formatMessage(filterMessages.publishers)}
        />
      </FilterToggle>

      <FilterToggle long title={formatMessage(filterMessages.languages)}>
        <ListFilter
          long
          attribute="languages"
          title={formatMessage(filterMessages.languages)}
        />
      </FilterToggle>

      <div className="d-none">
        {/* Dummy widget to allow FantasyVerse collection */}
        <FilterToggle long title={formatMessage(filterMessages.collections)}>
          <ListFilter
            long
            attribute="collections"
            title={formatMessage(filterMessages.collections)}
          />
        </FilterToggle>
      </div>
    </React.Fragment>
  );
}

SearchFilters.propTypes = {
  searchState: PropTypes.shape({}).isRequired,
  pathname: PropTypes.string,
};

SearchFilters.defaultProps = {
  pathname: '',
};
